<style lang="scss">
  .mdm-setup {

  }
</style>

<template>
  <!-- Error page-->
  <div>
    <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center mt-5">
      <h1>Verifying details, please wait...</h1>

      <b-spinner variant="primary" label="Loading"></b-spinner>
    </div>

    <h1 v-else>You do not have valid access to this app</h1>
  </div>
<!-- / Error page-->
</template>

<script>
import * as AuthService from '@/services/AuthService';
import axios from '@axios'
import { setRegion, getRestEndpoint } from '../../../endpoints';

export default {
  components: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {},
  mounted() {
    // uncomment for test
    // const token = '<token>'; // NOTE: Don't add Bearer
    // this.$store.dispatch('auth/setLocalUserToken', token);
    // this.$router.push({ name: 'dashboard' })

    // listen for a custom electron event
    window.addEventListener('electronSetup', data => {
      const Token = data.detail.token;
      const Country = data.detail.country;

      if (Country) {
        setRegion(Country); // Sets the region use in REST_ENDPOINT. Defaults to 'uk'.
      }

      // Set BaseURL based on region selected above.
      axios.defaults.baseURL = getRestEndpoint();

      if (Token) {
        this.$store.commit('SET_IS_ELECTRON', true);

        setTimeout(() => {
          AuthService.convertMdmToken(Token).then(res => {
            this.$store.dispatch('auth/setLocalUserTokens', res.data);
            this.$store.dispatch('sendStat', { meta: {}, description: 'Opened Purple Post Windows App' });
            this.$router.push({ name: 'dashboard' });
          }).catch(err => {
            console.log('You do not have valid access', err);
            this.loading = false;
          });
        });
      }
    });
  },
}
</script>
